import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from '@mui/material/Button';
import { useNotify } from 'react-admin';
import { useNavigate } from 'react-router-dom';
import { CREATE } from 'react-admin';

import dataProvider from '../utils/dataProvider';
import addUploadFeature from '../utils/addUploadCapabilities';
const uploadCapableClient = addUploadFeature(dataProvider);

class UploadAvatarButton extends Component {
      handleClick = () => {
          const { useNavigate, notify } = this.props;

          const updatedRecord = { 
                image: this.props.preview,
          };

          uploadCapableClient(CREATE, `user/upload-avatar`, { data: updatedRecord })
              .then((response) => {

                  if (response.data.avatar != null) {
                    localStorage.setItem('avatar', response.data.avatar);
                  }

                  //notify('Avatar uploaded');
                  useNavigate('/');
              })
              .catch((e) => {
                  console.error(e);
                  //notify('Error: avatar not uploaded', 'warning')
              });
      }
  
      render() {
          return <Button variant="raised" label="Approve" onClick={this.handleClick} >Upload</Button>;
      }
  }
  
  UploadAvatarButton.propTypes = {
      useNavigate: PropTypes.func,
      preview: PropTypes.object,
  };
  
  export default UploadAvatarButton;